import Card from "./Card";
import database from "../data/database.json";

const Cards = () => {
  return (
    <main className="cards-wrapper">
      {database.cards.map((card) => {
        return <Card key={card.key} cardData={card} />;
      })}
    </main>
  );
};

export default Cards;
